import React from 'react';
import { Link } from 'react-router-dom';
import Logo from '../Hero/Logo';

const Footer = () => {
  return (
    <footer className="bg-black text-white py-8 border-t border-gray-800">
      <div className="max-w-7xl mx-auto px-4">
        <div className="flex flex-col items-center space-y-6">
          {/* Logo */}
          <div className="flex items-center">
            <Logo size="small" className="w-[45px] md:w-[55px]" />
          </div>

          {/* Links */}
          <div className="flex flex-col sm:flex-row items-center space-y-4 sm:space-y-0 sm:space-x-6">
            <Link 
              to="/terms-of-use"
              className="text-[15px] text-gray-300 hover:text-white transition-colors"
            >
              Terms of Use
            </Link>
            <Link 
              to="/privacypolicy"
              className="text-[15px] text-gray-300 hover:text-white transition-colors"
            >
              Privacy Policy
            </Link>
            <Link 
              to="/disclaimer"
              className="text-[15px] text-gray-300 hover:text-white transition-colors"
            >
              Disclaimer
            </Link>
          </div>

          {/* Copyright */}
          <div className="text-gray-400 text-sm text-center">
            © {new Date().getFullYear()} Jacks. All rights reserved.
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;